import type {ValuationData} from "@reva/shared/valuation-data";

import type ServiceApi from "../../api";
import {RevaApi} from "../api-constants";
import {SimpleApiInterface} from "../api-interface";
import type {ApiCredentials} from "../credentials";
import type {ApiExecutor} from "../executor";

/**
 * API interface to reopen a finalized valuation for correction
 * (POST {@link RevaApi.PATH_VALUATIONS}/{id}/correction).
 *
 * Sends the parameters carried over from the final response (null when the first-finalize data is
 * already present) plus a mandatory comment.
 */
export class PersistenceCorrectionApiInterface extends SimpleApiInterface<ValuationData> {
    constructor(
        private readonly revaId: string,
        private readonly comment: string,
        private readonly firstFinalizeParameters: object | null,
    ) {
        super();
    }

    protected buildUrl(api: ServiceApi): string {
        return api.buildRevaApiUrl([RevaApi.PATH_VALUATIONS, this.revaId, RevaApi.PATH_VALUATION_CORRECTION]);
    }

    protected buildPayload(): object {
        return {inputParamsFromFinalResponse: this.firstFinalizeParameters, comment: this.comment};
    }

    protected async executeInternal(
        executor: ApiExecutor,
        url: string,
        credentials: ApiCredentials,
    ): Promise<ValuationData> {
        return executor.fetchPOST(url, credentials, this.buildPayload());
    }
}
